import React from 'react'
import FullScreenAsset from './FullScreenAsset'
import { useParams, useNavigate } from 'react-router'
import { useFetchWidenAsset } from '../../hooks/useFetchWidenAsset'
import { useLoadingIds } from '../../hooks/useLoadingIds'
import { CanAccess } from '../Elements/Access'
import EmptyLearningCenter from './EmptyLearningCenter'
import { useMountEffect } from '../../hooks/useMountEffect'
import useEndpoint from '../../hooks/useEndpoint'
import { extractedErrorObject, users } from '../../api/swagger'

const FullScreenContainer: React.FC = () => {
  const { widenAssetKey, academicYear } = useParams<{
    widenAssetKey: string
    academicYear: string
  }>()
  const navigate = useNavigate()

  const { LearningCenter, BusinessContent } = useLoadingIds()
  const parsedAssetKey = parseInt(`${widenAssetKey}`)
  const { contentAsset, isLoading, fetchAsset, errorFetchingContent } =
    useFetchWidenAsset({
      assetKey: parsedAssetKey,
      loadingId: LearningCenter.fetchContentDetail,
    })

  const { filetype, embedUrl } = contentAsset ?? {}

  const { triggerFetch: checkNdaStatus } = useEndpoint({
    loadingId: BusinessContent.fetchUserNdaStatus,
    swaggerCall: async () => {
      try {
        const { hasSignedNda, assetRequiresNda } =
          await users.fetchUserNdaStatus({
            assetKey: parsedAssetKey,
          })

        if (!assetRequiresNda) {
          // Asset doesn't require NDA, continue to show content
          return
        }
        if (assetRequiresNda && hasSignedNda) {
          // NDA already signed, continue to show content
          return
        }

        navigate(
          {
            pathname: `/business/consent/${parsedAssetKey}`,
          },
          {
            replace: true,
            state: { fromFullscreen: true, academicYear },
          }
        )
      } catch (err) {
        const errorObj = await extractedErrorObject(err)
        navigate(
          {
            pathname: '/Account/profile',
          },
          {
            replace: true,
          }
        )
        throw new Error(errorObj?.message)
      }
    },
  })

  useMountEffect(() => {
    fetchAsset()
    checkNdaStatus()
  })

  if (errorFetchingContent || !contentAsset) {
    return <EmptyLearningCenter isLoading={isLoading} />
  }

  return (
    <CanAccess I="learningCenter" on="Feature">
      <FullScreenAsset embedUrl={embedUrl} fileType={filetype} />
    </CanAccess>
  )
}

export default FullScreenContainer
